const LoginStatus = {
    "NotLoggedIn" : 0,
    "LoginOK" : 1,
    "FailedTimeRequests" : 3,
    "NotEmailFound" : 4
}


const SmsStatus = {
    "CodeCurrect" : 1,
    "TimeEnded" : 2,
    "FailedTimeRequests" : 3,
    "CodeWrong" : 4

}

const AppDataParam = {
    "set_app_data" : 0,
    "reset_search_param_places" : 1,
    "reset_search_param_dates_months" : 2,
    "reset_search_param_guests" : 3, 
    "reset_search_param_vacationCyclesYears" : 4,
    "reset_search_param_checkedWeekDays" : 5,
    "reset_search_param_dates_range" : 6,
    "reset_to_new_search_param_vacationCyclesYears" :7,
    "reset_last_chance" :8
}

const OrderMessages = {
    "timeOut" : 'זמן לביצוע הזמנה הסתיים.',
    "setnewdate" : '',
    "setlecturer": ''
}

const EntitlmentStatusTypes = {
    "EntitlementNotOrdered" : 10,
    "EntitlementOrderedNotRealized" : 20,
    "EntitlementDone" : 30,
    "EntitlementNotOrderedMessage": 'טרם ביצעת הזמנה עבור שנת זכאות זו' , 
    "EntitlementOrderedNotRealizedMessage" : 'הזמנת אך טרם ממשת את הזמנתך עבור שנת זכאות זו',
    "EntitlementDoneMessage":'הזמנת וכבר ממשת'
}



const  Weekdays_placeholder = (num) =>  { 

    switch (num) {
        case 3:
            return 'כל ימי השבוע';
        case 1:
            return 'אמצע שבוע';
        case 2:
            return 'סוף שבוע';

        default:
            return '';
   };
};



const WeekPeriodId = {
    "Weekmiddle" : 1,
    "Weekend" : 2,
    "WeekAll" : 3
}



const AreaId = {
    "Kineret" : 1,
    "Merchaz" : 2,
    "Jerusalem" : 3,
    "DeadSea" : 4,
    "Darom" : 5,
    "Eilat" : 6
}

export {
    AppDataParam,
    OrderMessages,
    Weekdays_placeholder,
    EntitlmentStatusTypes,
    LoginStatus,
    SmsStatus,
    WeekPeriodId,
    AreaId
  }